module.exports = __webpack_public_path__ + "img/tutorial_nine_en.b38ca83b.png";